import DataMenu from "../../constant/menu.json";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "../atoms/common";
import { Accordion } from "../atoms/custom";
import Environtment from "../../constant/environtment.json";
import { GlobalGet } from "../../helpers/fetcher";
import alertMessage from "../../helpers/alertMessage";

const Navbar = (props) => {
  const [menu, setMenu] = useState([]);
  const { REACT_APP_API_URL } = Environtment;
  const { basic, onScroll, logo } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const [environment, setEnvironment] = useState(basic);
  const [loading, setLoading] = useState(false);

  const fetchOurBusiness = async () => {
    setLoading(true);
    const newMenu = DataMenu;
    try {
      const response = await GlobalGet({
        url: `${REACT_APP_API_URL}business`,
      });
      if (response?.status === 200) {
        const subMenu = () => {
          const tempMenu = [];
          response?.data?.post?.map((subItem) => {
            tempMenu.push({
              menu: subItem?.title,
              link: `/our-work/${subItem?.slug}`,
              icon: "document",
              children: [],
            });
          });
          return tempMenu;
        };
        setLoading(false);
        newMenu.map((item) => {
          if (item.menu === "Our Business") {
            item.children = subMenu();
          }
        });
        setMenu(newMenu);
      } else {
        setLoading(false);
        alertMessage("error", response?.message, "Retry", () => {});
        setMenu(DataMenu);
      }
    } catch (err) {
      setLoading(false);
      alertMessage("error", "Network Error", "Retry", () => {});
      setMenu(DataMenu);
    }
  };

  useEffect(() => {
    fetchOurBusiness();
    const onScroll = () => setOffset(window.pageYOffset);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (onScroll) {
      if (offset > 0) {
        setEnvironment(onScroll || basic);
      } else {
        setEnvironment(basic);
      }
    }
  }, [basic, onScroll, offset]);
  // console.log("menu", menu);
  return (
    <nav
      className={`${environment.classes} ${
        open ? "tablet:h-full" : "tablet:h-fit"
      }`}
    >
      <div className="container flex flex-nowrap justify-between items-center">
        {logo && (
          <Link to="/" className="pb-2">
            <img src={logo} alt="..." className="w-72" />
          </Link>
        )}
        <div className="flex my-auto">
          <button
            data-collapse-toggle="mobile-menu-4"
            type="button"
            className="items-center p-2 text-sm rounded-lg hidden tablet:block hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="mobile-menu-4"
            aria-expanded="false"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        </div>
        <div
          className={`flex justify-between items-end w-auto ${
            open ? "tablet:flex" : "tablet:hidden"
          } tablet:w-full order-1`}
          id="mobile-menu-4"
        >
          <ul
            className={`${
              open && "h-full"
            } flex tablet:flex-col tablet:w-full tablet:mt-4 flex-row space-x-1 tablet:space-x-0 mt-0 text-xs font-thin`}
          >
            {DataMenu.map((item) => (
              <>
                {item.children.length < 1 ? (
                  <li>
                    <Button
                      handler={() => navigate(item.link, { replace: true })}
                      text={item.menu}
                      classes={`flex w-full h-full items-center pr-4 pl-3 py-2 hover:bg-transparent hover:text-white font-bold ${
                        location.pathname === item.link
                          ? "text-greenWebsite"
                          : "bg-transparent border-transparent text-white"
                      }`}
                    />
                  </li>
                ) : (
                  <li>
                    <Accordion parent={item.menu} children={item.children} />
                  </li>
                )}
              </>
            ))}
            <li>
              {" "}
              <Link to="/login/investor">
                <Button
                  classes={`flex w-full h-full items-center pr-4 pl-3 py-2 hover:bg-transparent hover:text-white font-bold bg-transparent border-transparent text-white`}
                  text="LP Login"
                />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  basic: PropTypes.object,
  onScroll: PropTypes.object,
  logo: PropTypes.string,
};

export default Navbar;
